export default __webpack_public_path__ + "static/media/ds-dark.90256347.svg";